import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { createIndexedDbStorage } from '@/utils/storage/indexeddb-storage';
import { TTL } from '@/utils/storage/localStorage-with-ttl';

const initialValues = {
  cart: {},
  items: [],
  totals: [],
  shippingAddress: null,
  showShippingMethods: false,
  showPayments: false,
  shippingMethods: [],
  activeShippingMethod: null,
  pickupStore: {},
  mainUserAddress: {},
  userAddresses: [],
  payments: null,
  regions: [],
  mobiles: {},
  tel: null,
  alrajhi: {
    mobileNumber: '',
    referenceId: '',
    step: 1,
  },
  qitaf: {
    mobileNumber: '',
    step: 1,
  },
  walaOne: {
    mobileNumber: '',
    referenceId: '',
    step: 1,
    amount: '',
  },
  mapLocation: null,
  activeLoyaltyPointsStep: null,
  prescriptionUploaded: false,
  prescriptionUrl: null,
};

const useCheckout = create(
  persist(
    (set) => ({
      ...initialValues,
      setCart: (cart) =>
        set(() => ({
          cart,
          items: cart?.items || [],
          totals: cart?.total_segments || [],
        })),

      setShippingAddress: (shippingAddress) => set(() => ({ shippingAddress })),

      setMapLocation: (mapLocation) => set(() => ({ mapLocation })),

      setShowShippingMethods: (showShippingMethods) =>
        set(() => ({ showShippingMethods })),

      setShowPayments: (showPayments) => set(() => ({ showPayments })),

      setShippingMethods: (shippingMethods) => set(() => ({ shippingMethods })),

      setActiveShippingMethod: (activeShippingMethod) =>
        set(() => ({ activeShippingMethod })),

      setPickupStore: (pickupStore) => set(() => ({ pickupStore })),

      setPayments: (payments) => {
        return set(() => ({ payments }));
      },
      setAlrajhi: (alrajhi) => set(() => ({ alrajhi })),

      setQitaf: (qitaf) => set(() => ({ qitaf })),

      setWalaOne: (walaOne) => set(() => ({ walaOne })),

      setRegions: (regions) => set(() => ({ regions })),

      setUserAddresses: (userAddresses) => set(() => ({ userAddresses })),

      setMainUserAddress: (mainUserAddress) => set(() => ({ mainUserAddress })),

      setTel: (tel) => set(() => ({ tel })),

      removeItem: (itemId) =>
        set((state) => {
          // Remove the item from the cart
          const updatedCartItems = state.cart?.items?.filter(
            (item) => item.item_id !== itemId
          );
          return {
            ...state,
            cart: { ...state?.cart, items: updatedCartItems },
          };
        }),

      setMobiles: ({ mobile, status }) =>
        set((state) => ({
          mobiles: { ...state.mobiles, [mobile]: status },
        })),

      setActiveLoyaltyPointsStep: (activeLoyaltyPointsStep) =>
        set(() => ({ activeLoyaltyPointsStep })),

      setPrescriptionUploaded: (uploaded, url = null) =>
        set(() => ({
          prescriptionUploaded: uploaded,
          prescriptionUrl: url,
        })),

      clearCheckout: () => set(initialValues),
    }),
    {
      name: 'checkout',
      storage: createIndexedDbStorage('checkout', TTL.ONE_DAY),
    }
  )
);

export default useCheckout;
